import React from 'react';
import { Create, useTranslate } from 'react-admin';
import Form from './detail/Form';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const CleanerCreate = (props) => {
  const translate = useTranslate();
  useDocumentTitle(
    translate('app.page_title.create', {
      resource: translate('resources.cleaner.name', { smart_count: 1 }),
    }),
  );
  return (
    <Create {...props}>
      <Form />
    </Create>
  );
};

export default CleanerCreate;
